module.exports = __webpack_public_path__ + "static/media/liquidity.f3145052.svg";